import * as actionTypes from "./DashboardType";

const INITIAL_STATE = {
  DashboardValue: [],
  DashboardCount: [],
  DashboardOutstanding: [],//{},
  DashboardTopOutstandingCustomer: [],
  
};

const DashboardReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETDASHBOARDVALUE:
      return {
        ...state,
        DashboardValue: action.payload.list.Data,
      };    
    case actionTypes.SETDASHBOARDCOUNT:
      return {
        ...state,
        DashboardCount: action.payload.list.Data,
      };
    case actionTypes.SETDASHBOARDOUTSTANDING:
      return {
        ...state,
        DashboardOutstanding: action.payload.list.Data,
      };
    case actionTypes.SETDASHBOARDTOPOUTSTANDINGCUSTOMER:
      return {
        ...state,
        DashboardTopOutstandingCustomer: action.payload.list.Data,
      };    
    default:
      return state;
  }
};

export default DashboardReducer;
